import axiosInstance from "../axiosInterceptor";

export async function readNotification(id) {
  const response = await axiosInstance.get(`student/readNotification/${id}`);
  const data = response?.data;
  return data;
}
